import { SelectOptionType } from '@octano/global-ui';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'reactstrap';
import DisplayError from '../../components/info/DisplayError';
import { TranslationsKeys } from '../../locales/translations';
import { PaginationQueryDto } from '../../types/paginationRequestType';
import { StudentWarningsSummaryDataLoader } from './loaders/StudentWarningsSummaryDataLoader';
import { useWarningsSummaryFormLoaderData } from './loaders/StudentWarningsSummaryFormLoader';
import StudentWarningsSummaryMainFilter from './parts/StudentWarningsSummaryMainFilter';
import StudentWarningsSummaryTabs from './parts/StudentWarningsSummaryTabs';
import { StudentWarningsSummaryDataParams } from './types';

const defaultFilters: PaginationQueryDto<StudentWarningsSummaryDataParams> = {
  items_per_page: 10,
  page: 1,
  warningGroupType: 'summary',
  periodId: undefined,
  schoolId: undefined,
};

const StudentWarningsSummary = () => {
  const data = useWarningsSummaryFormLoaderData();
  const { t } = useTranslation(TranslationsKeys.STUDENT_ALERTS_SUMMARY);

  const [mounted, setMounted] = useState(false);
  const [prevFilters, setPrevFilters] = useState(defaultFilters);

  const tabs = useMemo<SelectOptionType[]>(() => {
    const tabsItems = [...data.warningGroups];
    tabsItems.unshift({ label: t('summary'), value: 'summary' });
    return tabsItems;
  }, [data.warningGroups, t]);

  useEffect(() => {
    if (!mounted) {
      const storedFilters = localStorage.getItem('@studentAlerts/filters');
      if (storedFilters) {
        setPrevFilters(JSON.parse(storedFilters));
      }
      setMounted(true);
    }
  }, [mounted]);

  if (!data?.warningGroups?.length) {
    return (
      <div className="w-100 d-flex flex-wrap justify-content-center">
        <DisplayError textBody={t('noWarningGroups.description')} />
      </div>
    );
  }

  if (!mounted) {
    return <></>;
  }

  return (
    <div className="w-100 d-flex flex-wrap justify-content-center">
      <StudentWarningsSummaryDataLoader
        defaultQuery={prevFilters ?? defaultFilters}
        fetchImmediately
      >
        <StudentWarningsSummaryMainFilter />
        <Container fluid>
          <Row>
            <Col xs={12}>
              <StudentWarningsSummaryTabs tabs={tabs} defaultTab={tabs[0]} />
            </Col>
          </Row>
        </Container>
      </StudentWarningsSummaryDataLoader>
    </div>
  );
};

export default StudentWarningsSummary;
